import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: 'Is this payment portal secure?',
  answer: 'Yes. Our portal uses bank-level encryption and is fully PCI-DSS compliant. Your personal and financial information is transmitted securely and we do not store your full credit card details on our servers.'
}, {
  question: "What if I can't pay the full amount today?",
  answer: 'We understand that financial situations vary, and we can work with you. Many accounts qualify for flexible payment plans. Please sign in to your account to view available plan options, or call us directly to discuss an arrangement that fits your budget.'
}, {
  question: "I don't recognize this debt. What should I do?",
  answer: 'You have the right to request validation of any account. If you believe this is an error or do not recognize the account, please contact us at the number below. We will gladly provide written validation of the debt.'
}, {
  question: 'Will paying online affect my credit?',
  answer: 'Paying or resolving an account is reported in accordance with standard industry practices. Generally, resolving an outstanding debt is viewed favorably. For specific questions about credit reporting, please contact our office.'
}, {
  question: 'Can I dispute a charge or account?',
  answer: 'Yes. Disputes can be initiated directly through your online account portal once you sign in, or by contacting our office by phone or mail.'
}, {
  question: 'How do I get a receipt for my payment?',
  answer: 'Immediately after a successful payment, you will receive an email confirmation containing your receipt. You can also sign in to your account at any time to view and print your complete payment history.'
}];
export function PortalFAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section id="faq" className="py-16 bg-brand-gray" data-id="element-539">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-540">
        <div className="text-center mb-10" data-id="element-541">
          <h2 className="text-2xl md:text-3xl font-bold text-brand-navy mb-4" data-id="element-542">
            Common Questions
          </h2>
          <p className="text-brand-muted" data-id="element-543">
            We're here to provide clarity and help you resolve your account.
          </p>
        </div>

        <div className="space-y-3" data-id="element-544">
          {faqs.map((faq, index) => <div key={index} className="bg-white border border-gray-200 rounded-lg overflow-hidden shadow-sm" data-id="element-545">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-4 text-left flex justify-between items-center hover:bg-gray-50 transition-colors focus:outline-none focus:ring-2 focus:ring-brand-navy focus:ring-inset" aria-expanded={openIndex === index} data-id="element-546">
                <span className="font-semibold text-brand-dark pr-4" data-id="element-547">
                  {faq.question}
                </span>
                <ChevronDown size={20} className={`text-brand-muted shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-548" />
              </button>
              <AnimatePresence data-id="element-549">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-550">
                    <div className="px-6 pb-5 pt-1 text-brand-muted leading-relaxed border-t border-gray-100" data-id="element-551">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}